export default __webpack_public_path__ + "77581feac1f732067b4a8df41908ac0c.svg";